<template lang="pug">
.login-forget-password 
    v-label.login-forget-password--heading ah bon ? 🫢
    v-label.login-forget-password--description Vous avez oublié votre mot de passe ? Renseignez votre Email et nous nous occupons de tout.
    v-form(ref="loginForm" @submit="resetPassword")
        div
          .login-forget-password--input-container
            v-text-field(
              elevation="0"
              v-model='email'
              label='Email'
              name='email'
              variant="outlined"
              :error="emailError.isValid === false"
              :error-messages="emailError.message"
              density="compact"
              single-line
              @update:modelValue='checkIfEmailOrMobile'
            )
            .login-forget-password--input-container__icon
              v-icon epoca:loginUser
        v-btn.login-forget-password--button(variant="text" :disabled="sendingEmailProgress" @click="resetPassword")
            v-icon(right) epoca:loginKey
            v-label.login-forget-password--button__label ENVOYER
            v-progress-circular(v-if="sendingEmailProgress" indeterminate size="16" :width="2")
    v-label.login-forget-password--description--footer(v-if="resetPasswordEmailSend") Si un compte est associé à cette adresse, vous recevrez rapidement un Email vous permettant de mettre à jour votre mot de passe.
    .login-forget-password--goback-container(v-if="!isOTPVerified")
      v-btn.login-forget-password--goback-btn(variant="text" @click="goToLogin")
        v-label.login-forget-password--goback-btn__label Revenir à la page de connexion
</template>

<script setup lang="ts">
import { OAuthProvider, getAuth, signInWithCredential } from 'firebase/auth'
const isEmailAuthent = ref(false)
const loginForm: any = ref(null)
const resetPasswordEmailSend = ref(false)
const email = ref('')
const sendingEmailProgress = ref(false)
const route = useRoute()
const emailError = ref({
  isValid: true,
  message: '',
})

const { sendEmailAndPassword, sendSMSCode, sentResetPasswordLink, applyRecaptcha, multiFactorWithSMS, sendPhoneNumber } =
  useAuth()

const checkIfEmailOrMobile = (e: string) => {
  emailError.value.isValid = true
  emailError.value.message = ''
  if (isEmail(e)) isEmailAuthent.value = true
  else {
    isEmailAuthent.value = false
  }
}

const { $toast: toast, $api: api } = useNuxtApp()

const isEmail = (v: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    v,
  )
}

const goToLogin = () => {
  navigateTo('/')
}

const isEmailOrMobile = (v: string) => {
  return isEmail(v) || "Le format n'est pas valide"
}

const resetPassword = async () => {
  if (!isEmailAuthent.value || sendingEmailProgress.value) {
    emailError.value.isValid = false
    emailError.value.message = 'Format invalide'
    return false
  }

  sendingEmailProgress.value = true
  await sentResetPasswordLink(email.value)
  resetPasswordEmailSend.value = true
  sendingEmailProgress.value = false
}

onMounted(async () => {
  if (route.query.email) {
    email.value = decodeURIComponent(route.query.email as string)
    checkIfEmailOrMobile(email.value)
  }
})
</script>

<style lang="stylus" scoped>
.login-forget-password
  align-items flex-start
  display flex
  flex-direction column
  flex 1
  &--goback-container
    display flex
    justify-content center
    margin-top 32px
  &--goback-btn
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
  &--input-container
    position relative
    :deep().v-input
      &__details
        color var(--Primary-Warning, #FF4D6A)
        padding-left 0
        body-b3-regular()
    :deep().v-field
      border-radius 4px
      background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
      border-left 4px solid transparent
      &__outline
        display none
      &--error
        border-left 4px solid var(--Primary-Warning, #FF4D6A)
      .v-label.v-field-label
        margin-left 8px
        padding-right 25px
        color var(--Text-4, #747474)
        body-b3-medium()
      input
        padding-left 8px
        padding-right 50px
        color var(--Text-8, #1F1F1F)
        body-b3-medium()
    &__icon
      position absolute
      top: 10px;
      right: 8px;
      height: 20px;
      padding-left: 5px;
      border-left 1px solid var(--Text-3, #A4A4A4)
      display: flex
      align-items: center;
      justify-content: center;
      .v-icon
        height 20px
        width 20px
        color var(--Text-4, #747474)

  &--button
    display: flex;
    height: 40px;
    padding: 0px 24px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    width: 100%;
    border-radius: 4px;
    background: var(--Primary-Brand-Lime, #97FF8C);
    &__label
      color: var(--Text-8, #1F1F1F)
      body-b3-semibold()
      opacity 1
    :deep().v-btn
      &__content
        gap: 8px;
  &--password-reset
    color var(--Text-6, #3B3B3B)
    padding 0
    height auto
    &__label
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      cursor pointer
      opacity 1
      text-transform none
  &--heading
    color: var(--Text-8, #1F1F1F)
    title-t3-uppercase()
    opacity 1
  &--description
    color: var(--Text-6, #3B3B3B)
    body-b4-medium()
    opacity 1
    width: 100%
    white-space: pre-wrap
    margin-top: 80px
    margin-bottom: 32px
    &--footer
      color: var(--Text-6, #3B3B3B)
      body-b4-medium()
      opacity 1
      width: 100%
      white-space: pre-wrap
      margin-top: 32px
      margin-bottom: 0
  .v-form
    display flex
    width: 100%;
    gap 15px
    flex-direction column
    .login-otp
      &--input-container
        :deep().v-otp-input
          padding-top 0
          &__content
            height: 56px;
            padding: 0.5rem 0;
        :deep().v-field
          border-radius 4px
          background var(--Textfield-Input-BG-Dark, rgba(0, 0, 0, 0.08)) !important
          &__outline
            display none
          input
            color var(--Text-8, #1F1F1F)
            otp-n3-bold()
        .otp-message
          white-space inherit
    .v-btn
      align-self: end;
  h3
    margin-top 20px
</style>
